import { render } from "./DatasourceCreate.vue?vue&type=template&id=684fec76"
import script from "./DatasourceCreate.vue?vue&type=script&lang=js"
export * from "./DatasourceCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/DatasourceCreate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "684fec76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('684fec76', __exports__)) {
    api.reload('684fec76', __exports__)
  }
  
  module.hot.accept("./DatasourceCreate.vue?vue&type=template&id=684fec76", () => {
    api.rerender('684fec76', render)
  })

}


export default __exports__